<app-header></app-header>
<ng-container>
  <ion-content
    [scrollEvents]="true"
    (ionScroll)="handleScroll($event)"
    scroll-x="true"
    forceOverscroll="true"
  >
    <ion-grid>
      <div class="compare-content">
        <div class="compare-layout">
          <app-product-comparison
            [shouldConvertToPopover]="shouldConvertToPopover"
            [isGuestUser]="isGuestUser$ | async"
          ></app-product-comparison>
        </div>
      </div>
    </ion-grid>
    <app-footer class="compare-footer"></app-footer>
  </ion-content>
</ng-container>
